import { app } from '../../../app';

// when we have st-select-row on a table row, clicking the row selects the item bound to that row.
// if we also have a link on a child cell, then both the link and the parent row receives
// the click event. link is activated, but also the checkbox is toggled.
// to avoid this, we extend the `stSelectRow` directive to stop event propagation.

app.directive('stSelectRow', () => (scope, element) => {
    element.on(
        'click',
        '[ng-click], [ng-href], [ui-sref], [uib-dropdown]',
        (e) => e.stopPropagation(),
    );
});



// WEBPACK FOOTER //
// ./src/portal/components/smart-table/select/st-select-row.directive.js